import React from 'react';
import { Form, withFormik } from 'formik';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import { DDadosTitle } from '@common/components/ddados';
import * as commonActionType from '@common/store/common/common.actionsType';
import accessControlValidator from '@common/validators/accessControl.validator';

class NestedForm extends React.Component {
  onKeyDownCapture(e) {
    if (e.key === 'Enter') {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLSelectElement ||
        (e.target instanceof HTMLButtonElement && e.target.type !== 'button')
      ) {
        e.preventDefault();
        this.props.onSubmit(e);
      }
    } else if (e.key === 'Space') {
      this.checkForSubmitButton(e);
    }
  }

  checkForSubmitButton(e) {
    if (e.target instanceof HTMLButtonElement && e.target.type !== 'button') {
      this.props.onSubmit(e);
    }
  }

  render() {
    const { onSubmit, ...props } = this.props;

    return (
      <div
        onKeyDownCapture={this.onKeyDownCapture.bind(this)}
        onClick={this.checkForSubmitButton.bind(this)}
        role="form"
        {...props}
      />
    );
  }
}

const FormComponent = ({ children, onSubmit, className, isSubForm, preventSubmitOnEnter }) => {
  const submitForm = (e) => {
    if (e.target.name != 'filtro_form') {
      onSubmit(e);
    }
  };
  if (!isSubForm)
    return (
      <Form
        onSubmit={submitForm}
        onKeyDownCapture={(e) => {
          if (preventSubmitOnEnter && e.key === 'Enter') e.preventDefault();
        }}
        className={className}
        noValidate
      >
        {children}
      </Form>
    );
  else
    return (
      <NestedForm className={className} onSubmit={onSubmit}>
        {children}
      </NestedForm>
    );
};

export { FormComponent };

class FormValidation extends React.Component {
  constructor(props) {
    super();
    this.state = {
      values: undefined,
    };
  }

  componentDidMount() {
    PubSub.subscribe(commonActionType.RESET_FORM, this.onResetForm.bind(this));
    PubSub.subscribe(commonActionType.RESET_HASH_FORM, this.onResetHashForm.bind(this));
    PubSub.subscribe(commonActionType.SET_FIELD_VALUE, _.debounce(this.onSetFieldValue.bind(this), 1000));

    let currentLocation;
    if (this.props.prefix) currentLocation = window.location.hash;
    window.isView = this.props.prefix === 'V';
    window.prefix = this.props.prefix;

    if (this.props.formControl && !window.isView) {
      window._formControl = this.props.formControl;
      window.formUpdated = undefined;
      window.onbeforeunload = function (e) {
        return window.prefix ? 'Há alterações não salvas.' : undefined;
      };

      let { routerManager } = this.props;

      if (routerManager) {
        window.onpopstate = function (event) {
          let nextLocation = window.location.hash;
          history.pushState('', document.title, currentLocation);
          routerManager.redirect({
            url: nextLocation.substring(1),
          });
        };
      }
    }
  }

  // shouldComponentUpdate(nextProps) {
  //   return this.props.shouldUpdate || JSON.stringify(nextProps.values) != JSON.stringify(this.props.values);
  // }

  onSetFieldValue(act, values) {
    this.props.onChangeForm && this.props.onChangeForm(values);
  }

  onResetForm(act, values) {
    if (this.props.hash && values.hash === this.props.hash) this.props.resetForm();
    else {
      this.props.resetForm();
      PubSub.publish(commonActionType.RESET);
    }
  }

  onResetHashForm(act, values) {
    if (this.props.hash && values.hash === this.props.hash) {
      this.props.resetForm();
      PubSub.publish(commonActionType.RESET);
    }
  }

  onCancel(prefix) {
    window.prefix = prefix;
    this.props.onCancel && this.props.onCancel();
  }

  componentWillUnmount() {
    window.formUpdated = undefined;
  }

  verifyPermission(url) {
    if (!url) return true;
    return accessControlValidator.checkPermissionByUrl(url);
  }

  render() {
    const {
      className,
      onPrint,
      onCancel,
      onEdit,
      onSubmit,
      onExecute,
      onClear,
      onSubFormSubmit,
      onSubmitGeneric,
      onSubmitFilter,
      onAssociated,
      onCustomButtom,
      middleCustomButton,
      values,
      initialValues,
      notButton,
      onCancelVisible,
      prefix,
      title,
      boxForm,
      removeWell,
      onlyEdit,
      onModalSubmit,
      hash,
      button,
      preventSubmitOnEnter,
    } = this.props;
    const { props } = this;

    const isView = prefix == 'V';

    const { handleSubmit } = props;
    return (
      <Row>
        <Col>
          {title && <DDadosTitle prefix={prefix} title={title} />}
          <div className={boxForm && !removeWell ? 'well' : ''}>
            <FormComponent
              onSubmit={(e) => {
                setTimeout(() => {
                  if ($('.error > small').length > 0) {
                    $([document.documentElement, document.body]).animate(
                      {
                        scrollTop: $('.error > small').offset().top - 120,
                      },
                      1000
                    );
                  } else {
                    window.formUpdated = undefined;
                  }
                });

                e.stopPropagation();
                handleSubmit(e);
              }}
              preventSubmitOnEnter={preventSubmitOnEnter}
              isSubForm={onSubFormSubmit || onSubmitFilter}
              className={`${className || ''} ${boxForm ? 'box-form-cadastro' : ''}`}
              noValidate
            >
              {_.isFunction(this.props.children) ? this.props.children(props) : this.props.children}
              {!onSubmitFilter &&
                !onSubmitGeneric &&
                (onCancel ||
                  onSubmit ||
                  onSubFormSubmit ||
                  onModalSubmit ||
                  onExecute ||
                  onClear ||
                  onEdit ||
                  onPrint ||
                  onAssociated ||
                  onCustomButtom ||
                  middleCustomButton) &&
                !notButton && (
                  <Row className={`${!boxForm ? 'float-right' : ''}`}>
                    <Col className="btn-forms">
                      {button && button()}
                      {onPrint && (
                        <button type="button" className="btn btn-primary" onClick={onPrint}>
                          Imprimir Solicitação Completa <i className="fas fa-print ml-2" />
                        </button>
                      )}
                      {onCancel && (
                        <button type="button" className="btn btn-cancel" onClick={() => this.onCancel(prefix)}>
                          <i className={`fa ${isView ? 'fa-angle-double-left' : 'fa-ban'}`} />{' '}
                          {`${isView ? 'Voltar' : 'Cancelar'}`}
                        </button>
                      )}
                      {onClear && onCancelVisible && (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            onClear(values, this.props);
                          }}
                        >
                          <i className="fas fa-eraser" /> Limpar
                        </button>
                      )}
                      {middleCustomButton && (
                        <>
                          <button
                            type={middleCustomButton.type}
                            disabled={middleCustomButton.disabled}
                            className={middleCustomButton.className || 'btn btn-primary'}
                            title={middleCustomButton.tooltip}
                            onClick={() => {
                              middleCustomButton.type === 'submit'
                                ? props.setValues({ ...values, submitAction: i })
                                : middleCustomButton.onClick && middleCustomButton.onClick();
                            }}
                          >
                            <i className={middleCustomButton.classNameIcon || ''} /> {middleCustomButton.chilldren}
                          </button>
                        </>
                      )}
                      {onSubmit && (!onlyEdit || (onlyEdit && onEdit)) && !isView && (
                        <button type="submit" className="btn btn-primary">
                          <i className={`fas ${onEdit === false ? 'fa-plus' : 'fa-check'}`} />{' '}
                          {`${onEdit === false ? 'Incluir' : 'Confirmar'}`}
                        </button>
                      )}
                      {onSubFormSubmit && (
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                          <i className="fa fa-save" /> Salvar Sub
                        </button>
                      )}
                      {onModalSubmit && (
                        <button type="submit" className="btn btn-primary">
                          <i className="fas fa-check" /> Confirmar
                        </button>
                      )}
                      {onExecute && (
                        <button type="submit" className="btn btn-primary">
                          <i className="fas fa-cogs" /> Executar
                        </button>
                      )}
                      {onAssociated && (
                        <button type="submit" className="btn btn-primary">
                          <i className="fas fa-link" /> Associar
                        </button>
                      )}
                      {onCustomButtom &&
                        onCustomButtom.map((x, i) => (
                          <>
                            {this.verifyPermission(x.url) && (
                              <button
                                type={x.type}
                                disabled={x.disabled}
                                className={x.className || 'btn btn-primary'}
                                onClick={() => {
                                  x.type === 'submit'
                                    ? props.setValues({ ...values, submitAction: i })
                                    : x.onClick && x.onClick();
                                }}
                              >
                                <i className={x.classNameIcon || ''} /> {x.chilldren}
                              </button>
                            )}
                          </>
                        ))}
                    </Col>
                  </Row>
                )}
            </FormComponent>
          </div>
        </Col>
      </Row>
    );
  }
}

const EnhancedForm = withFormik({
  mapPropsToValues: (props) => props.initialValues || {},
  handleSubmit: (values, form) => {
    const {
      onSubmit,
      onExecute,
      onSubFormSubmit,
      onSubmitFilter,
      onSubmitGeneric,
      onModalSubmit,
      onEdit,
      onPrint,
      onAssociated,
      onCustomButtom,
    } = form.props;
    const onSubmitFormComponent =
      onSubmit ||
      onSubFormSubmit ||
      onModalSubmit ||
      onSubmitGeneric ||
      onSubmitFilter ||
      onExecute ||
      onEdit ||
      onPrint ||
      onAssociated ||
      (Array.isArray(onCustomButtom) && onCustomButtom.length !== 0
        ? onCustomButtom[values.submitAction]?.onClick
        : undefined);
    onSubmitFormComponent && onSubmitFormComponent(values, form);
  },
  validateOnChange: true,
  validateOnBlur: true,
  displayName: 'BasicForm',
})(FormValidation);

export const isInvalidForm = (form) =>
  !form || (form?.errors == Object(form?.errors) ? Object.keys(form.errors)?.length > 0 : false);

export default EnhancedForm;
